<template>
  <b-container fluid style="margin-top:90px;">
    <b-card v-if="loading" style="margin-top:90px;" class="text-center">
      <b-spinner label="Loading..."></b-spinner>
    </b-card>

    <b-card v-if="!loading">
      <b-button variant="outline-info" v-on:click="createAssignmentClicked">{{$t("CREATE_ASSIGNMENT")}}</b-button>
    </b-card>
    <b-card v-if="!loading" class="mt-1">
      <b-table striped outlined hover :items="assignments" :fields="fields" @row-clicked="rowClicked" >
        
        
<!--        <template slot="StartPoint" slot-scope="row">-->
<!--          <span v-if="row.StartPoint > 0">{{row.StartPoint}}</span>-->
<!--        </template>-->
<!--        <template slot="EndPoint" slot-scope="row">-->
<!--          <span v-show="row.EndPoint > 0">{{row.EndPoint}}</span>-->
<!--        </template>-->
        
      </b-table>
    </b-card>
  </b-container>
</template>
<script>
import { ajaxGet, ajaxPost } from "../../ajax";
import {apiUrl} from "@/main";

export default {
    data: function() {
    return {
      loading: false,
      assignments: [],
      fields: [
        { key: "ID", label: this.$t("ID") , sortable: true, thClass: 'd-none', tdClass: 'd-none'},
        { key: "Title", label: this.$t("TITLE"), sortable: true},
        { key: "ClassName", label: this.$t("CLASSNAME"), sortable: true },
        { key: "AssignedOn", label: this.$t("ASSIGNED_ON"), sortable: true },
        { key: "DueOn", label: this.$t("DUE_ON"), sortable: true },
        { key: "StartPoint" , label: this.$t("BEGIN_PAGE"), },
        { key: "EndPoint" , label: this.$t("END_PAGE")},
      ],
    };
  },
  props: ["token"],
  mounted: function() {
    this.loading = true;

    var assignmentsPanel = this;

    setTimeout(function() {
      ajaxGet(
         apiUrl() + "/assignments?RootOnly=true",
        assignmentsPanel.dataSuccessLoad,
        assignmentsPanel.dataError,
        assignmentsPanel.token
      );
    }, 50);


    //window.alert(this.token);
  },
  methods: {
    dataSuccessLoad: function(res) {
      this.assignments = res;
      this.loading = false;
      //commenting out incase they state they want us to hide the 0 page values 
      // this.assignments.forEach((value, index, array) => {
      //   if(value.StartPoint === 0 && value.EndPoint === 0){
      //     this.pageValues = true;
      //   }
      // });
      
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }
    },
    rowClicked(record, index) {
        this.$router.push({ path: "/assignments/results/" + record.ID});
    },
    createAssignmentClicked(event) {
      event.preventDefault();

      this.$router.push({ path: "/assignments/create"  });
    }
  }
}
</script>

<!--Commenting out incase they want us to hide the 0 page values-->
<!--<style scoped>-->
<!--.hidePageValues{-->
<!--  visibility: hidden;-->
<!--}-->

<!--</style>-->
